/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';


export const bulk = (state = defaultState.bulk, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        categories = [];

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.BULK_LIST:
                nextState.items = action.payload;
                break;

            case constants.BULK_DELETE:
                break;

            case constants.BULK_UPLOAD:
                nextState.token = action.payload.token;
                break;

            case constants.BULK_STATUS:
                if (action.payload.progress !== undefined) {
                    nextState.status = action.payload.progress;
                } else {
                    nextState.token = 0;
                    nextState.status = null;
                    nextState.searchResults = action.payload;
                }
                break;

            case constants.BULK_BATCH:
                break;

            case constants.BULK_UPDATE:
                break;

            case constants.BULK_POST:
                nextState.completedImports++;
                break;

            case constants.BULK_HINTS:
                nextState.hints = action.payload;
                nextState.searchResults = [];
                break;

            case constants.BULK_RESULTS:
                nextState.searchResults = action.payload;
                nextState.hints = {};
                break;

            case constants.BULK_RESET:
                nextState.hints = {};
                nextState.searchResults = [];
                nextState.items = [];
                break;

            default:
                break;
        }
    } else if (action.status === constants.STATE_ERROR) {
        switch (action.payload.type) {
            case constants.BULK_HINTS:
                nextState.hints = {};
                nextState.searchResults = [];
                break;

            case constants.BULK_RESULTS:
                nextState.searchResults = [];
                nextState.hints = {};
                break;

            // a check on an upload that fails ends the wait for it
            case constants.BULK_STATUS:
                nextState.token = 0;
                nextState.status = null;
                break;

            default:
                break;
        }
    }

    return nextState;

};
